module.exports = {
    "id": "melon",
    "title": "melon",
    "image": "provision/parts/melon/melon.png",
    "info": [
      {
        "text": "Add a melon to your project",
        "image": "provision/parts/melon/melon.png"
      }
    ],
    "exposedVariables": [
    ],
    "codeImage": "provision/parts/melon/melon.png"
  };